import React from 'react';

interface GlassModalProps {
  message: string;
  onClose: () => void;
}

const GlassModal: React.FC<GlassModalProps> = ({ message, onClose }) => (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(12px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 2000,
  }} onClick={onClose}>
    <div style={{
      background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(20px)',
      borderRadius: 24, padding: '30px 24px', maxWidth: 420, width: '90%',
      textAlign: 'center', position: 'relative',
      border: '1px solid rgba(255,255,255,0.5)',
      boxShadow: '0 20px 50px rgba(0,0,0,0.15)',
    }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 16, color: '#1a1a2e', lineHeight: 1.6, whiteSpace: 'pre-line' }}>
        {message}
      </div>
      <button onClick={onClose} style={{
        marginTop: 20, background: 'linear-gradient(135deg, #6a11cb, #2575fc)',
        color: 'white', border: 'none', borderRadius: 40, padding: '10px 28px',
        fontSize: 15, fontWeight: 600, cursor: 'pointer', boxShadow: '0 8px 20px rgba(37,117,252,0.3)',
      }}>Понятно</button>
    </div>
  </div>
);

export default GlassModal;
